// eslint-disable-next-line import/prefer-default-export
export const selectTours = (state) => state.tours.tours;
